
const orderNote = document.querySelector('.js-order-note');

if(orderNote) {
    const orderNoteToggle = orderNote.querySelector('.js-order-note-toggle');


    orderNoteToggle.addEventListener('click', (e) => {
        if(orderNote.hasAttribute('data-active')) {
            orderNote.removeAttribute('data-active');
        } else {
            orderNote.setAttribute('data-active', '');

        }
    })

}
